import customers from './api/customers';
import drivers from './api/drivers';
import sites from './api/sites';
import tours from './api/tours';
import tour_models from './api/tour_models'
import tour_types from './api/tour_types'
import users from './api/users';
import loading_states from './api/loading_states';
import tour_states from './api/tour_states';
import site_model_number from './api/model_numbers'
import tour_loadings from "./api/tour_loadings";
import auth from "./api/auth";
import payment_modes from "./api/payment_modes";
import messages from "./api/messages";

export default {
    auth,
    customers,
    drivers,
    sites,
    tours,
    tour_models,
    tour_types,
    users,
    loading_states,
    tour_states,
    tour_loadings,
    site_model_number,
    messages,
    payment_modes
}

